import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

/**
 * Format a notification createdDate for "from now" display.
 * Parses the value as UTC (API sends ISO with Z), then uses .local().fromNow()
 * so "now" and the notification time are compared in the user's local timezone.
 *
 * @param {string|Date} dateValue - createdDate from API (ISO 8601, preferably with Z)
 * @param {string} language - i18n language code (e.g. "fr")
 * @returns {string} Relative time string (e.g. "il y a quelques secondes")
 */
export function formatNotificationDateAsFromNow(dateValue, language) {
  const raw = dateValue;
  const asUtc =
    typeof raw === "string" && raw.length > 0 && !raw.endsWith("Z")
      ? `${raw}Z`
      : raw;
  return dayjs.utc(asUtc).local().locale(language).fromNow();
}
